import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	Typography,
	DialogActions,
} from '@mui/material';

import { hideLoginModal, selectUiState } from 'redux/ui/uiSlice';
import { ROUTE_BASE, ROUTE_LOGIN } from 'constants/routerPath';

const LoginModal: React.FC = () => {
	const dispatch = useDispatch();
	const { isLoginModalOpen } = useSelector(selectUiState);

	return (
		<Dialog
			open={isLoginModalOpen}
			onClose={() => dispatch(hideLoginModal())}
		>
			<DialogTitle>Session Expired</DialogTitle>
			<DialogContent>
				<Typography>
					You have been logged out. Please log in to continue the
					session. Your unsaved data will be lost.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						dispatch(hideLoginModal());
					}}
					variant="outlined"
				>
					Back
				</Button>
				<Button
					color="error"
					variant="contained"
					onClick={() => {
						dispatch(hideLoginModal());
						window.location.href = ROUTE_BASE + ROUTE_LOGIN; // Redirect without using navigate
					}}
				>
					Log in
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LoginModal;
